import { useLogout } from "@/features/auth/useLogout";

// TODO: Remove after implemented user fetching for Azure Auth
export const AuthNotImplementedPage = () => {
    const logout = useLogout();

    return (
        <div>
            <div>Authentication strategy not implemented.</div>
            <button onClick={() => logout()}>Logout</button>
        </div>
    );
};
